<div class="slide mr-5">
	<div class="testimonial-card bg-white ptb-10 border-radius-15">
		<div class="border-bottom">
			<div class="testimonial-card-header d-flex pse-10 pb-5">
				<img class="w-100 max-50 mre-7 rounded-circle h-45" [src]="image" alt="img" defaultImage />
				<div>
					<div class="person-name size-4 weight-700">{{ name }}</div>
					<div class="rate d-flex">
						<div class="star"><img class="w-100 max-10 mre-2" src="../../../../assets/images/star.svg"
								alt="star">
						</div>
						<div class="star"><img class="w-100 max-10 mre-2" src="../../../../assets/images/star.svg"
								alt="star">
						</div>
						<div class="star"><img class="w-100 max-10 mre-2" src="../../../../assets/images/star.svg"
								alt="star">
						</div>
						<div class="star"><img class="w-100 max-10 mre-2" src="../../../../assets/images/star.svg"
								alt="star">
						</div>
						<div class="star"><img class="w-100 max-10" src="../../../../assets/images/star.svg" alt="star">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="testimonial-card-body pse-10 pt-5">
			<div class="paragraph size-3 lines-4">{{ content }}</div>
		</div>
	</div>
</div>